import React, { useEffect, useState } from 'react'
import styles from './channelAdd.jcss'
import EditText from '../../../blocks.simple/editText/editText'
import translate from '../../../core/translate'
import Button from '../../../blocks.simple/button/button'
import CatalogSelectContent from '../../../blocks.app/catalog/_select/_content/catalog_select_content'
import Dropdown from '../../../blocks.simple/dropdown/dropdown'
import { api } from '../../../core/api/ConnectionManager'
import { SwitchButton } from '../../../atoms/SwitchButton'
import { cn } from 'ethcss'
import Checkbox from '../../../blocks.simple/checkbox/checkbox'
import { isArguments } from 'lodash'

export const ChannelAdd = ({ channel, onChange, onClose, onSave }: any) => {
    const [categories, setCategories] = useState([])

    const presetValues = [
        { title: translate('NetUp'), id: 'NetUp' },
        { title: translate('Ugoos 01'), id: 'Ugoos01' },
        { title: translate('Ugoos 02'), id: 'Ugoos02' },
        { title: translate('manualSettings'), id: 'manualSettings' },
    ]
    const vlcViewTypeValues = [
        { title: translate('vlc_layout'), id: 'vlc_layout' },
        { title: translate('surface'), id: 'surface' },
        { title: translate('texture'), id: 'texture' },
    ]

    const getDefaultPreset = (name?: string) => {
        switch (name) {
            case 'NetUp':
                return {
                    vlcSettingString:
                        '--audio-time-stretch --avcodec-skiploopfilter 1 --avcodec-skip-frame 0 --avcodec-skip-idct 0 --subsdec-encoding   --stats --audio-resampler soxr --freetype-rel-fontsize=16 --freetype-color=16777215 --freetype-opacity=255 --freetype-background-opacity=0 --freetype-shadow-color=0 --freetype-shadow-opacity=128 --freetype-outline-thickness=4 --freetype-outline-color=0 --freetype-outline-opacity=255 --keystore file_crypt none -vvv --no-sout-chromecast-audio-passthrough --sout-chromecast-conversion-quality=2 --sout-keep --smb-force-v1 --preferred-resolution=-1 --repeat --network-caching=1000',
                    vlcViewType: 'surface',
                    useExoIfCan: false,
                    name,
                    enabled: true,
                }
            case 'Ugoos01':
                return {
                    vlcSettingString:
                        '--audio-time-stretch --avcodec-skiploopfilter 1 --avcodec-skip-frame 0 --avcodec-skip-idct 0 --subsdec-encoding   --stats --audio-resampler soxr --freetype-rel-fontsize=16 --freetype-color=16777215 --freetype-opacity=255 --freetype-background-opacity=0 --freetype-shadow-color=0 --freetype-shadow-opacity=128 --freetype-outline-thickness=4 --freetype-outline-color=0 --freetype-outline-opacity=255 --keystore file_crypt none -vvv --no-sout-chromecast-audio-passthrough --sout-chromecast-conversion-quality=2 --sout-keep --smb-force-v1 --preferred-resolution=-1 --vout=android_display',
                    vlcViewType: 'vlc_layout',
                    useExoIfCan: false,
                    name,
                    enabled: true,
                }
            case 'Ugoos02':
                return {
                    vlcSettingString:
                        '--audio-time-stretch --avcodec-skiploopfilter 1 --avcodec-skip-frame 0 --avcodec-skip-idct 0 --subsdec-encoding   --stats --audio-resampler soxr --freetype-rel-fontsize=16 --freetype-color=16777215 --freetype-opacity=255 --freetype-background-opacity=0 --freetype-shadow-color=0 --freetype-shadow-opacity=128 --freetype-outline-thickness=4 --freetype-outline-color=0 --freetype-outline-opacity=255 --keystore file_crypt none -vvv --no-sout-chromecast-audio-passthrough --sout-chromecast-conversion-quality=2 --sout-keep --smb-force-v1 --preferred-resolution=-1 --vout=android_display --repeat --network-caching=1000',
                    vlcViewType: 'vlc_layout',
                    useExoIfCan: false,
                    name,
                    enabled: true,
                }
            case 'manualSettings':
                return {
                    vlcSettingString:
                        '--audio-time-stretch --avcodec-skiploopfilter 1 --avcodec-skip-frame 0 --avcodec-skip-idct 0 --subsdec-encoding   --stats --audio-resampler soxr --freetype-rel-fontsize=16 --freetype-color=16777215 --freetype-opacity=255 --freetype-background-opacity=0 --freetype-shadow-color=0 --freetype-shadow-opacity=128 --freetype-outline-thickness=4 --freetype-outline-color=0 --freetype-outline-opacity=255 --keystore file_crypt none -vvv --no-sout-chromecast-audio-passthrough --sout-chromecast-conversion-quality=2 --sout-keep --smb-force-v1 --preferred-resolution=-1 --repeat --network-caching=1000',
                    vlcViewType: 'surface',
                    useExoIfCan: false,
                    name,
                    enabled: true,
                }
            default:
                return {
                    enabled: false,
                    name: 'NetUp',
                    vlcViewType: 'surface',
                    vlcSettingString:
                        '--audio-time-stretch --avcodec-skiploopfilter 1 --avcodec-skip-frame 0 --avcodec-skip-idct 0 --subsdec-encoding   --stats --audio-resampler soxr --freetype-rel-fontsize=16 --freetype-color=16777215 --freetype-opacity=255 --freetype-background-opacity=0 --freetype-shadow-color=0 --freetype-shadow-opacity=128 --freetype-outline-thickness=4 --freetype-outline-color=0 --freetype-outline-opacity=255 --keystore file_crypt none -vvv --no-sout-chromecast-audio-passthrough --sout-chromecast-conversion-quality=2 --sout-keep --smb-force-v1 --preferred-resolution=-1 --repeat --network-caching=1000',
                }
        }
    }

    useEffect(() => {
        api.send('getCategoryList', {
            limit: 1000,
            sort: [['id', 'ASC']],
        }).then((res: any) => {
            if (!res && !res.data) return

            setCategories(res.data)
        })
    }, [])

    const onChangePreset = (field: string, value: string | boolean) => {
        let preset
        if (field === 'name' && value == 'manualSettings') {
            preset = channel.preset ? channel.preset : getDefaultPreset('manualSettings')
        } else if (field === 'name' && value !== 'manualSettings') {
            preset = getDefaultPreset(value as string)
        } else {
            preset = channel.preset ? channel.preset : getDefaultPreset()
        }

        const updatedPreset = {
            ...preset,
            [field]: value,
        }

        onChange('preset', updatedPreset)
    }

    return channel ? (
        <div className={styles.channelAdd}>
            <div className={styles.inner}>
                <div className={styles.field}>
                    <EditText
                        value={channel.title}
                        onChange={(value: string) => {
                            onChange('title', value)
                        }}
                        containerClass={styles.separator}
                        className={styles.input}
                        label={translate('name')}
                    />
                </div>
                <div className={styles.field}>
                    <EditText
                        type="number"
                        min={1}
                        value={channel.channelNumber}
                        onChange={(value: string) => {
                            onChange('channelNumber', value)
                        }}
                        containerClass={styles.separator}
                        className={styles.input}
                        label={translate('number')}
                    />
                </div>
                <div className={styles.field}>
                    <EditText
                        value={channel.channelUrl}
                        onChange={(value: string) => {
                            onChange('channelUrl', value)
                        }}
                        containerClass={styles.separator}
                        className={styles.input}
                        label={translate('ipOrLink')}
                    />
                </div>
                <div className={styles.field}>
                    <Dropdown
                        mod={'default'}
                        options={categories}
                        valueField={'title'}
                        labelField={'title'}
                        label={translate('category')}
                        value={channel && channel.category && channel.category.title}
                        onChange={(value: any) => onChange('category', value)}
                    />
                </div>
                <div className={cn(styles.field, styles.twinField)}>
                    <Dropdown
                        mod={'default'}
                        options={presetValues}
                        valueField={'id'}
                        labelField={'title'}
                        label={translate('preset')}
                        value={channel && channel.preset && channel.preset.name}
                        onChange={(value: any) => onChangePreset('name', value.id)}
                        disabled={!channel.preset || !channel.preset.enabled}
                    />
                    <div className={styles.switchWrapper}>
                        <SwitchButton
                            checked={channel && channel.preset && channel.preset.enabled}
                            onChange={() => {
                                onChangePreset('enabled', !(channel && channel.preset && channel.preset.enabled))
                            }}
                        />
                    </div>
                </div>

                {channel && channel.preset && channel.preset.name === 'manualSettings' && (
                    <>
                        <div className={styles.field}>
                            <Dropdown
                                mod={'default'}
                                options={vlcViewTypeValues}
                                valueField={'id'}
                                labelField={'title'}
                                label={translate('vlcViewType')}
                                value={channel && channel.preset && channel.preset.vlcViewType}
                                onChange={(value: any) => {
                                    onChangePreset('vlcViewType', value.id)
                                }}
                                disabled={!channel.preset || !channel.preset.enabled}
                            />
                        </div>
                        <div className={styles.field}>
                            <EditText
                                value={channel && channel.preset && channel.preset.vlcSettingString}
                                onChange={(value: string) => {
                                    onChangePreset('vlcSettingString', value)
                                }}
                                containerClass={styles.separator}
                                className={cn(
                                    styles.input,
                                    channel.preset && channel.preset.enabled ? '' : styles.inputDisabled
                                )}
                                label={translate('VLCSettings')}
                                disabled={!channel.preset || !channel.preset.enabled}
                            />
                        </div>
                        <div className={cn(styles.field, styles.twinField)}>
                            <Checkbox
                                labelClassName={styles.label}
                                wrapperClassName={
                                    !(channel && channel.preset && channel.preset.enabled) ? styles.inputDisabled : ''
                                }
                                disabled={!channel.preset || !channel.preset.enabled}
                                label={translate('exoAsPriority')}
                                checked={channel && channel.preset && channel.preset.useExoIfCan}
                                onClick={() => {
                                    onChangePreset(
                                        'useExoIfCan',
                                        !(channel && channel.preset && channel.preset.useExoIfCan)
                                    )
                                }}
                            />
                        </div>
                    </>
                )}
                <div style={{ width: 100, height: 120 }}>
                    <CatalogSelectContent
                        label={translate('logo')}
                        type={'image'}
                        selectedInfo={channel.logo ? channel.logo : null}
                        onSelect={(selectedMedia: { id: number; src: string }) => {
                            onChange('logo', selectedMedia)
                        }}
                        selectedItemStyles={{ width: 70, marginRight: 20 }}
                        itemStyles={styles.itemStyles}
                        className={styles.selectLogo}
                    />
                </div>
                <div className={styles.recommendedImage}>{translate('iptvRecommendedImageSize')}</div>
                <div className={styles.controls}>
                    <Button mod={'withBorder'} className={styles.button} onClick={onClose}>
                        {translate('cancel')}
                    </Button>
                    <Button
                        mod="fill"
                        className={styles.button}
                        onClick={onSave}
                        disabled={!channel.title || !channel.channelUrl}
                    >
                        {translate(channel.id ? 'save' : 'create')}
                    </Button>
                </div>
            </div>
        </div>
    ) : null
}
